module.exports = __webpack_public_path__ + "img/4.68beeaa1.png";